import About from "@/components/About";
import CtaBand from "@/components/CtaBand";

export default function AboutPage() {
  return (
    <main data-testid="page-about" className="pt-[72px]">
      <About />
      <CtaBand />
    </main>
  );
}
